<template>
    <div class="drives-footer">
        <h6>{{ message }}</h6>
        <v-progress-linear :model-value="width"
            :color="width == 100 ? 'error' : 'green'">
        </v-progress-linear>
    </div>
</template>

<script>
import Utils from '@topomatic/tap/src/utils';
import AppConsts from '../consts';

export default {
    name: 'UsageView',
    props: {
        group: Object,
    },
    data() {
        return {
            capacity: null,
            used: null,
        };
    },
    computed: {
        message() {
            let s = this.$tr('Использовано {0} из {1}').replace('{0}', Utils.sizeToString(this.used || 0));
            if (this.capacity == undefined) {
                s = s.replace('{1}', '?');
            } else {
                s = s.replace('{1}', Utils.sizeToString(this.capacity));
            }
            return s;
        },
        width() {
            const { used } = this;
            if (used == undefined) {
                return 0;
            }
            const { capacity } = this;
            if (capacity == undefined) {
                return 0;
            }
            return Math.round((used * 100) / capacity);
        },
    },
    methods: {
        fetchData() {
            this.$api.getUsage(this.group.id == AppConsts.APP_GROUP_MY ? null : this.group.id)
                .then((json) => {
                    this.capacity = json.capacity;
                    this.used = json.used;
                });
        },
    },
    mounted() {
        this.fetchData();
    },
    beforeUpdate() {
        this.fetchData();
    },
};
</script>

<style scoped>
.drives-footer {
    width: 100%;
    text-align: center;
    padding: 8px;
}
</style>
